const Styles = {
  iconContainer: {
    display: 'flex',
    width: 40,
    height: 30,
    justifyContent: 'center',
    alignItems: 'center'
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/components/common/listItems/styles.js